module.exports = __webpack_public_path__ + "img/image17.6bb494f6.png";